// extracted by mini-css-extract-plugin
module.exports = {"typeTickets":"styles_typeTickets__5o6-7","ticketFilter":"styles_ticketFilter__2SGal"};